export default __webpack_public_path__ + "faef9d1c8034236f3cf10c3cf078912e.svg";